module.exports = __webpack_public_path__ + "static/media/clothing.fc6bea1c.png";